import React from 'react';
import '../../assets/css/case-home.css';
import caseBackgroundIcon from '../../assets/images/case-background-dark.svg';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken } from '@vibesites/runtime/react';

export function AccessibilityPageHero() {
  const title = useContentToken('accessibilitypagehero.title');

  return (
    <section className="case-aboutpage-hero">
      <div className="case-aboutpage-hero-overlay" role="presentation" aria-hidden="true">
        <img src={caseBackgroundIcon} alt="Case & Associates logo accent background" />
      </div>
      <div className="case-container">
        <nav aria-label="Breadcrumb">
          <ol className="case-breadcrumb">
            <li><a href="/">Home</a></li>
            <li aria-current="page">
              <EditableToken path="accessibilitypagehero.title" type="text" label="Page Title" defaultValue={contentSchema.tokens['accessibilitypagehero.title'].defaultValue} as="span">
                {title}
              </EditableToken>
            </li>
          </ol>
        </nav>
        <EditableToken path="accessibilitypagehero.title" type="text" label="Page Title" defaultValue={contentSchema.tokens['accessibilitypagehero.title'].defaultValue} as="h1">
          {title}
        </EditableToken>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'AccessibilityPageHero',
  displayName: 'Accessibility Page Hero',
  tokens: {
    'accessibilitypagehero.title': {
      label: 'Page Title',
      type: 'text',
      defaultValue: 'Case & Associates Accessibility Statement',
    },
  },
};

(AccessibilityPageHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default AccessibilityPageHero;
